import React from 'react';
import { Link } from 'react-router-dom';
import { useInstitucion } from '../context/InstitucionContext';
import MarcaPusah from '../components/MarcaPusah';

// Modo plataforma: el primer segmento de la ruta no corresponde a ninguna institución activa.
const InstitucionNoEncontrada = () => {
  const { nombreMarca } = useInstitucion();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-8 gap-8">
      <MarcaPusah className="h-10" />
      <div className="bg-white rounded-2xl shadow-sm p-12 text-center max-w-md border border-gray-200">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Institución no encontrada</h1>
        <p className="text-gray-500 mb-6">
          La dirección no corresponde a ninguna institución publicada en {nombreMarca}.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
        >
          Ver instituciones
        </Link>
      </div>
    </div>
  );
};

export default InstitucionNoEncontrada;
